<script setup lang="ts">
import { PV } from "@/widgets";
import Icon from "~icons/tabler/refresh";

defineEmits<{
    click: [];
}>();
</script>

<template>
    <PV.Button v-tooltip.right="'Generate'" class="p-0!" link @click="$emit('click')">
        <Icon class="text-black hover:cursor-pointer" />
    </PV.Button>
</template>
